import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../../../core/services/notification/notification.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TransactionResult } from '../../../../../core/services/interfaces/transaction-result';
import { IEvidenceTypes } from '../../Interfaces/IEvidenceTypes';
import { SitesService } from '../../services/sites-services';
import { UploadFileService } from '../../services/upload-file.service';
import { EvidenceTypesService } from '../../services/evidencetypes-services';
import { TranslateService } from '../../../../../core/services/translate-service';
import { TranslateApplicationService } from '../../../../../core/translate/translate-application-service';
import { PropertiesService } from '../../services/properties-services';
import { IProperties } from '../../Interfaces/IProperties';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Integer } from 'aws-sdk/clients/apigateway';
import { IDocumentsTypes } from '../../Interfaces/IDocumentsTypes';
import { IDocumentsSuppliersVisits } from '../../Interfaces/IDocumentsSuppliersVisits';
import { VisitsService } from '../../services/visits-service';

@Component({
  selector: 'app-upload-document',
  templateUrl: './upload-document.component.html',
  styles: [
  ]
})
export class UploadDocumentComponent implements OnInit {
	
  formGroup: FormGroup;
	loading = false;

	selectedFiles: FileList;
	countEvidences: Integer = 0;
	documentsSuppliersVisits: IDocumentsSuppliersVisits = {
		pk_document_supplier_visit: 0,
    document_supplier_visit: '',
    fk_visit: 0,
    fk_document_type: 0,
    name_inbucket: '',
    creation_date: new Date(),
    fk_employee_creator: 0,
    last_updated: new Date(),
    fk_employee_updater: 0,
    available: false,
    username: '',
	fk_site: 0,
	document_type:''
	};
	BUCKET: string = '';
	REGION: string = '';
	FOLDER: string = '';
	NAME: string = '';
  fileType: number = 0;
  validExtensionFile: boolean = false;

	constructor(
		public dialogRef: MatDialogRef<UploadDocumentComponent>,
		@Inject(MAT_DIALOG_DATA) public data: IDocumentsSuppliersVisits,
		public notificationService: NotificationService,
		public translateService: TranslateService,
		public siteService: SitesService,
		public uploadFileService: UploadFileService,
		public formBuilder: FormBuilder,
		public translate: TranslateApplicationService,
		public propertyService: PropertiesService,
		public evidenceTypeService: EvidenceTypesService,
    public httpClient: HttpClient,
    public visitsService: VisitsService
	) {
		this.formGroup = this.formBuilder.group({
			pkdocumentsuppliesvisit: [
				data.pk_document_supplier_visit == null ? 0 : data.pk_document_supplier_visit,
			]
		});
  }
  
	ngOnInit(): void {	
  }

  AddEvidence() {
    this.loading = true;
		this.visitsService
			.UploadDocument(this.documentsSuppliersVisits)
			.subscribe(
				(result: TransactionResult<boolean>) => {
          if (result.success) {
            this.loading = false;
						this.Alert("Success", "COMPLETE");
						this.dialogRef.close(true);
          } else {
            this.loading = false;
            this.Alert("Error", "MYREQUEST.Error_loading_file");
          }
				},
				(error: any) => { this.ErrorAlert(error); this.loading = false; },
			);
  }
  
  Alert(title: string, message: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: this.translate.TranslateKey(message),
			shown: true,
		});
  }

  AlertProperties(title: string, message: string, property: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: this.translate.TranslateKey(message) + ": " + property,
			shown: true,
		});
  }
  
  Close() {
		this.dialogRef.close(false);
  }
  
  ConfigureIncident(result: TransactionResult<any>, file: File) {
    this.loading = true;
		var url = result.data.url;
		const formData = new FormData();
		var a = result.data.fields['Content-Type'];
		formData.append('Content-Type', result.data.fields['Content-Type']);
		formData.append('key', result.data.fields.key);
		formData.append('AWSAccessKeyId', result.data.fields.AWSAccessKeyId);
		formData.append('policy', result.data.fields.policy);
		formData.append('signature', result.data.fields.signature);
		formData.append(
			'x-amz-security-token',
			result.data.fields['x-amz-security-token'],
		);
    formData.append('file', file);
		return { url, formData };
	}
  
  ErrorAlert(message: any) {
		this.notificationService.AddAlert({
		  icon: 'all_inbox',
		  title: 'Error',
		  message: message,
		  shown: true,
		});
  }

	ExtensionFileSuccess(
		result: TransactionResult<IEvidenceTypes[]>,
		file: File,
	) {
		this.loading = true;
		this.fileType = result.data[0].pkevidencetype;
		this.propertyService
			.GetPropertyByName('BUCKET_APPLICATION_PATH')
			.subscribe(
				(result: TransactionResult<IProperties[]>) => {
					if (result.success) {
						this.FOLDER = result.data[0].propertyvalue;
						this.NAME =
							this.GetUniqueId(10) +
							'.' +
							file.name.split('.')[1];
						this.loading = true;
						this.propertyService
							.GetPropertyByName('S3_Bucket_PRESIGNED_URL_API')
							.subscribe(
								(presignedAPIURLResult: TransactionResult<IProperties[]>) => {
									if (presignedAPIURLResult.success) {
										this.EvidenceDataConfiguration(
											file,
											presignedAPIURLResult,
										);
                  }else{
                    this.loading = false;
                    this.AlertProperties("Error", "WARNINGS.Property_not_found", "S3_Bucket_PRESIGNED_URL_API");
                  }
								},
								(error: any) => { this.ErrorAlert(error); this.loading = false; },
							);
          } else {
            this.loading = false;
            this.AlertProperties("Error", "WARNINGS.Property_not_found", "BUCKET_APPLICATION_PATH");
          }
				},
				(error: any) => { this.ErrorAlert(error); this.loading = false; },
			);
	}

	EvidenceDataConfiguration(
		file: File,
		presignedAPIURLResult: TransactionResult<IProperties[]>,
  ) {
    this.loading = true;
		this.uploadFileService
			.UploadPreSignedUrl(
				this.FOLDER + 'SupplierDocuments/' + this.NAME,
				file.type,
				presignedAPIURLResult.data[0].propertyvalue,
			)
      .subscribe((result: TransactionResult<any>) => {
				if (result.success) {
					var { url, formData } = this.ConfigureIncident(
						result,
						file,
					);
					this.httpClient
						.post(url, formData, {
							observe: 'events',
							reportProgress: true,
						})
						.subscribe((result) => {
							if (result.type === HttpEventType.UploadProgress) {
							} else if (result.type == HttpEventType.Response) {
                this.loading = true,
								this.notificationService.AddAlert({
									icon: 'all_inbox',
									title: 'Success',
									message:
										this.translate.TranslateKey(
											'NDAs.File_uploaded',
										),
									shown: true,
								});

								this.documentsSuppliersVisits.document_supplier_visit = file.name;
                this.documentsSuppliersVisits.fk_visit = this.data.fk_visit;
                this.documentsSuppliersVisits.name_inbucket = 'SupplierDocuments/' + this.NAME;
                this.documentsSuppliersVisits.fk_document_type = this.data.fk_document_type;
								this.AddEvidence();
							}
						});
        } else {
          this.loading = false;
          this.Alert("Error", "MYREQUEST.Error_loading_file");
        }
			});
  }
  
  GetUniqueId(parts: number): string {
    this.loading = true;
		const stringArr = [];
		for (let i = 0; i < parts; i++) {
			const S4 = (((1 + Math.random()) * 0x10000) | 0)
				.toString(16)
				.substring(1);
			stringArr.push(S4);
    }
		return stringArr.join('-');
	}

	SelectFile(event) {
    this.selectedFiles = event.target.files;
    this.ValidateExtensionFiles();
  }

  UpdateEvidence() {
		this.loading = true;
		this.visitsService
			.UploadDocument(this.documentsSuppliersVisits)
			.subscribe(
				(result: TransactionResult<boolean>) => {
          if (result.success) {
            this.loading = false;
						this.Alert("Success", "COMPLETE");
						this.dialogRef.close(true);
          }else{
            this.loading = false;
            this.Alert("Error", "ERROR.Failed_to_update_file");
          }
				},
				(error: any) => { this.ErrorAlert(error); this.loading = false; },
			);
	}
  
  UploadDocument() {
		this.loading = true;
    for (var i = 0; i < this.selectedFiles.length; i++) {
      const file = this.selectedFiles.item(i);
      var filename = file.name.substr(file.name.lastIndexOf('.') + 1);
      this.evidenceTypeService
        .GetEvidenceTypeByExtensionFile('.' + filename)
        .subscribe(
          (result: TransactionResult<IEvidenceTypes[]>) => {
            if (result.success) {
              if (result.data[0] != null) {
                this.ExtensionFileSuccess(result, file);
              } else {
                this.loading = false;
                this.Alert("Warning", "ERROR.ExtensionError");
              }
            } else {
              this.loading = false;
              this.Alert("Warning", "ERROR.Extesnion_type_not_found");
            }
          },
          (error: any) => { this.ErrorAlert(error); this.loading = false; },
        );
    }
  }

  ValidateExtensionFiles() {
    this.validExtensionFile = true;
    for (var i = 0; i < this.selectedFiles.length; i++) {
      const file = this.selectedFiles.item(i);
      if (file.type != 'application/pdf') {
        this.validExtensionFile = false;
        break;
      }
    }
  }
}
